import React from "react"

import ClapImg from "@shared/assets/images/img_clap.png"
import { useAccount } from "@shared/contexts"
import { toHHmm } from "@shared/modules"

import { URL, WOW_MONEY_UNIT_PRICE } from "live/constants"

interface Props {
  /** 방송에 입장한 시각 */
  enteredAt: number
}

const Enter: React.FC<Props> = ({ enteredAt }) => {
  const {
    account: { viewer },
  } = useAccount()

  return (
    <div className="coinCont coinLoginAfter">
      <img src={ClapImg} alt="" />
      <div className="coinTxt">
        <strong>
          <span className="time">[{toHHmm(enteredAt)}]</span>{" "}
          <span className="colorOrange">{viewer?.username}</span>님
        </strong>
        <strong>방송 시청 1시간 마다</strong>
        <strong>
          <span className="colorOrange">
            와우머니 {WOW_MONEY_UNIT_PRICE.toLocaleString()}원
          </span>{" "}
          씩~
        </strong>
      </div>
      <a
        href={URL.WHAT_IS_WOW_MONEY}
        target="_blank"
        rel="noopener noreferrer"
        className="whatCoinLink"
      >
        와우머니란?
      </a>
    </div>
  )
}

export default Enter
